import { colors } from '../../../theme/color-palette';
import * as constants from '../../../constants/constant';

export function getChartProps(weekFilter, chartData, isUnit) {
	const isColumn = weekFilter <= 0 && chartData?.length <= 1;
	const chartValue = [
		{
			value: 'lyValue',
			name: constants.LAST_YEAR,
			chartLine: '6,3',
			color: isColumn ? colors.COLUMN_SERIES : colors.PURPLE,
			chartType: isColumn ? 'Column' : 'Line',
			isUnit,
		},
		{
			value: 'tyValue',
			name: constants.THIS_YEAR,
			chartLine: '0',
			color: isColumn ? colors.LIGHT_PURPLE : colors.PURPLE,
			chartType: isColumn ? 'Column' : 'Line',
			isUnit,
		},
	];
	const xAxisData = {
		date: 'busDt',
		nonDate: weekFilter === 0 ? 'busDt' : 'wmYrWkNbr',
	};
	return {
		chartValue,
		xAxisData,
	};
}

export const getErrorScreenParams = (type, errorCode) => {
	const showTitle = type !== 'item';
	let errorMsg = '';
	if (errorCode === 204) {
		switch (type) {
			case 'item':
				errorMsg = constants.INVENTORY_ITEM_DATA_NOT_AVAILABLE;
				break;
			case 'brand':
				errorMsg = constants.DATA_NOT_AVAILABLE;
				break;
		}
	} else {
		errorMsg = constants.ERROR_SCREEN_MSG_STORE;
	}
	return {
		showTitle,
		errorMsg,
	};
};

/**
 * Channel breakdown util methods
 */
const template = [
	{ channelName: 'S2H', tyValue: 0, lyValue: 0, yoy: 0 },
	{ channelName: 'S2S', tyValue: 0, lyValue: 0, yoy: 0 },
	{ channelName: 'BIS', tyValue: 0, lyValue: 0, yoy: 0 },
	{ channelName: 'SFS', tyValue: 0, lyValue: 0, yoy: 0 },
	{ channelName: 'DELIVERY', tyValue: 0, lyValue: 0, yoy: 0 },
	{ channelName: 'PICKUP', tyValue: 0, lyValue: 0, yoy: 0 },
];
export function prepareData(param = []) {
	let result = [];
	const availableChannels = [];
	Array.from(param).forEach((element) => {
		element.tyValue = element.tyValue || 0;
		element.lyValue = element.lyValue || 0;
		element.yoy = element.yoy || 0;
		availableChannels.push(element?.channelName);
	});

	result = result.concat(param);
	template.forEach((item) => {
		if (!availableChannels.includes(item.channelName)) {
			result.push({
				channelName: item?.channelName,
				tyValue: item.tyValue || 0,
				lyValue: item.lyValue || 0,
				yoy: item.yoy || 0,
			});
		}
	});

	const isEverythingZero = result.every((e) => e.tyValue === 0);
	if (isEverythingZero) {
		return [];
	}

	return [...result];
}
